import { useCartContext } from "app/providers/CartProvider";
import { Fragment, useMemo } from "react";
import {
  CreateCartPayload,
  GetOrderResponse,
} from "shared/api/middleware-api-client";
import Icon, { IconTypes } from "shared/ui/icon";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";

const DOOR_USPS = [
  { title: "Inmeetservice", description: "Gratis" },
  { title: "Levering en montage", description: "Inclusief" },
  { title: "Glasreinigerset cadeau", description: "Inclusief" },
];

const DOOR_SELF_ASSEMBLE_USPS = [
  {
    title: "Op maat gemaakt in eigen fabriek",
    description: "",
  },
  { title: "Glasreinigerset cadeau", description: "" },
  { title: "30 dagen niet tevreden, geld terug", description: "" },
];

export const BUSINESS_USPS = [
  { title: "Uit eigen fabriek in Vlaardingen", description: "" },
  { title: "Op maat voor een vaste prijs", description: "" },
  { title: "Snelle levering door heel Nederland", description: "" },
];

export const BUSINESS_PROFILE_USPS = [
  { title: "Uit eigen fabriek in Vlaardingen", description: "" },
  { title: "Snelle levering door heel Nederland", description: "" },
];

interface ProductItemExtraProps {
  className?: string;
  entity: CreateCartPayload | GetOrderResponse;
}

const ProductItemExtra = ({
  className = "",
  entity,
}: ProductItemExtraProps) => {
  const {
    isSampleSale,
    containsZakelijkProducts,
    containsOnlyZakelijkProfiles,
  } = useCartContext();
  const usps = useMemo(() => {
    if ("products" in entity && entity.products.length !== 0) {
      if (containsOnlyZakelijkProfiles) return BUSINESS_PROFILE_USPS;
      if (containsZakelijkProducts) return BUSINESS_USPS;
      if ("isSelfAssembly" in entity && entity.isSelfAssembly) {
        return DOOR_SELF_ASSEMBLE_USPS;
      }
      return DOOR_USPS;
    }
    return [];
  }, [entity]);

  if (!(usps.length > 0) || isSampleSale) return <></>;

  return (
    <>
      <div
        className={concatClassnames(
          "gg-grid gg-h-fit gg-w-full gg-grid-cols-12 gg-gap-y-2.5 sm:gg-gap-y-3.5 md:gg-h-full lg:gg-h-fit",
          className,
        )}
      >
        {usps.map((usp, i) => (
          <Fragment key={i}>
            <div className="gg-col-span-9 gg-whitespace-nowrap">
              <Text className="gg-flex gg-items-center">
                <Icon name={IconTypes.CHECK} className="gg-mr-2.5" />
                {usp.title}
              </Text>
            </div>
            <div className="gg-col-span-3 gg-text-right">{usp.description}</div>
          </Fragment>
        ))}
      </div>
    </>
  );
};
export default ProductItemExtra;
